export default __webpack_public_path__ + "static/media/btn_character_alignment_right.10963e42.svg";